import { createShallowStore, createStore } from '@frontend/store';
import { DefaultInsuranceDetailsValues } from '../constants';
import { InsuranceDetails } from '../types';

export type VerifiedInsuranceDetailsByPersonIDType = InsuranceDetails & { personId: string };

type VerifiedInsuranceDetailsType = {
  verifiedInsuranceDetails: VerifiedInsuranceDetailsByPersonIDType;
  setVerifiedInsuranceDetails: (details: VerifiedInsuranceDetailsByPersonIDType) => void;
};

export const useGetVerifiedInsuranceDetailsStore = createStore<VerifiedInsuranceDetailsType>(
  (set) => ({
    verifiedInsuranceDetails: { ...DefaultInsuranceDetailsValues, personId: '' },
    setVerifiedInsuranceDetails: (details) => set({ verifiedInsuranceDetails: details }),
  }),
  {
    name: 'verified-insurance-details-store',
  }
);

export const useGetVerifiedInsuranceDetailsShallowStore = createShallowStore<VerifiedInsuranceDetailsType>(
  useGetVerifiedInsuranceDetailsStore
);
